import { useQuery } from '@apollo/client'

import {
  getSentSurveysForDoctor,
  getSentSurveysForDoctorVariables,
  UserType,
} from '../../../../models/graphqlTypes'
import { DoctorPatientSurvey } from '../../../../views/doctor/Treatments/types/surveys.types'
import { SENT_SURVEYS_FOR_DOCTOR } from '../../../../operations/dashboardOperations'
import { useUserType } from '../../../hooks'
import { getSurveyListReturn } from '../dashboard.utils'

type Options = {
  variables: Pick<
    getSentSurveysForDoctorVariables,
    'filterData' | 'paginationInput'
  >
}

type ReturnData = {
  loading: boolean
  surveys: DoctorPatientSurvey[]
  totalSurveys: number
  hasMoreSurveys: boolean
  fetchingMore: boolean
  refetch: () => void
  fetchMoreSurveys: (options: Options) => void
}

export const useSentSurveysForDoctor = (options: Options): ReturnData => {
  const userType = useUserType()
  const isDoctor = userType === UserType.Doctor

  const { data: doctorData, ...doctorResults } = useQuery<
    getSentSurveysForDoctor,
    getSentSurveysForDoctorVariables
  >(SENT_SURVEYS_FOR_DOCTOR, {
    ...options,
    skip: !isDoctor,
  })

  return getSurveyListReturn(doctorResults, doctorData?.getSentSurveysForDoctor)
}
